import { createSlice } from '@reduxjs/toolkit';

const workoutCustomizationSlice = createSlice({
	name: 'workoutCustomization',
	initialState: {
		// Store customizations by workoutId
		customizations: {},
		// Store the list of selected workouts with their data
		selectedWorkouts: [],
		// Store the currently editing workout index
		editingWorkoutIndex: null,
	},
	reducers: {
		setWorkoutCustomization: (state, action) => {
			const { workoutId, customExercises } = action.payload;
			state.customizations[workoutId] = customExercises;

			// If we're editing an existing workout, update it in the selectedWorkouts
			if (state.editingWorkoutIndex !== null) {
				state.selectedWorkouts[state.editingWorkoutIndex] = {
					...state.selectedWorkouts[state.editingWorkoutIndex],
					customExercises,
				};
				state.editingWorkoutIndex = null;
			}
		},
		addWorkoutToSelection: (state, action) => {
			const workout = action.payload;
			state.selectedWorkouts.push(workout);
		},
		updateSelectedWorkout: (state, action) => {
			const { index, workout } = action.payload;
			state.selectedWorkouts[index] = workout;
		},
		removeWorkoutFromSelection: (state, action) => {
			const index = action.payload;
			state.selectedWorkouts.splice(index, 1);
		},
		setEditingWorkoutIndex: (state, action) => {
			state.editingWorkoutIndex = action.payload;
		},
		clearAllWorkouts: (state) => {
			state.selectedWorkouts = [];
			state.customizations = {};
			state.editingWorkoutIndex = null;
		},
	},
});

export const {
	setWorkoutCustomization,
	addWorkoutToSelection,
	updateSelectedWorkout,
	removeWorkoutFromSelection,
	setEditingWorkoutIndex,
	clearAllWorkouts,
} = workoutCustomizationSlice.actions;

export default workoutCustomizationSlice.reducer;
